import { createAsyncThunk } from '@reduxjs/toolkit';
import { setToken, removeToken } from '../../services/auth/index.js';
import { G as GenerateCustomerToken, C as CreateCustomer } from '../../GenerateCustomerToken-nBNO7Rhh.js';
import { G as GetCustomerInfo } from '../../GetCustomerInfo-QRC3rgNh.js';
import { b as publicMutate, a as privateQuery } from '../../requestsCollection-hvMBC1_v.js';
import { extractErrorMessage } from '../../utils/error.js';
import logger from '../../utils/logger.js';
import 'cookies-next';
import '../../currency-_kacFJHO.js';
import '../../language-BHHwgtQp.js';
import '../../payment-5CMab_Gs.js';
import '../../utils/currency.js';
import 'lodash/get';
import '../../utils/price.js';
import '../../product-_pRduMz7.js';
import 'react';
import '../../context/index.js';
import 'next/server';
import '../../index-Oip0gjfj.js';
import 'next/router';
import '../../helpers-qyZpLI0y.js';
import 'lodash';
import '../../index-QrdBfapu.js';
import 'lodash/cloneDeep';
import { d as dataLayerRegister } from '../../register-J9OaMUYD.js';
import { assignCartFromGuestToLogged, deleteCartSessionId, deleteCartGtmData } from '../../utils/cart.js';
import { addProductToWishlistAfterAuth } from '../../utils/wishlist.js';
import { createWishlist, clearWishlist } from '../wishlist/index.js';
import { f as trackLeadConfirmation } from '../../kwkUni-2OQfB-dG.js';
import '../../utils/logToSlack.js';
import '../../utils/cookies.js';
import '../../cookies-l-jEMp6P.js';
import '../../utils/isBot.js';
import '../../graphqlRequestClient-7kdUKc_c.js';
import 'graphql-request';
import '../../utils/fetchPolicyLookup.js';
import '../../serverErrors-XxD2s73I.js';
import '../../utils/logToRelic.js';
import 'number-currency-format';
import '../../utils/product.js';
import '../../paths-ZKN3m62_.js';
import '../../MergeCarts-wo9UjKo5.js';
import '../../ProcessReactivateCart-fk5bSKoR.js';
import '../../cart-i--GxEee.js';
import '../wishlist/thunks.js';
import '../../RemoveProductsFromWishlist-WCaYiZlq.js';
import '../../wishlist-foOHzuD7.js';
import '../../utils/parseJSON.js';
import '../../localStorage-NWX6x-k6.js';
import '../../utils/transformWishlistModel.js';
import '../genericSlice.js';
import 'lodash/set';
import '../../types/index.js';
import '../../checkout-ArxiEbYP.js';
import '../../menu-0TyOg98i.js';
import '../../modal-6vnX5SO3.js';
import '../wishlist/initialState.js';

const login = createAsyncThunk('user/login', async (payload, { extra, rejectWithValue, dispatch }) => {
    try {
        const { apolloConfig } = extra;
        const token = await publicMutate(apolloConfig(), {
            mutation: GenerateCustomerToken,
            variables: payload,
        }).then(res => res.data.generateCustomerToken.token);
        setToken(token);
        const userInfo = await privateQuery(apolloConfig(), {
            query: GetCustomerInfo,
        }, 'GetCustomerInfo').then(res => res.data.customer);
        const { wishlists, ...currentUser } = userInfo;
        dispatch(createWishlist(wishlists));
        // Add product to the wishlist after login
        await addProductToWishlistAfterAuth(dispatch, wishlists);
        // Assign shopping cart after login
        await assignCartFromGuestToLogged(apolloConfig);
        return currentUser;
    }
    catch (e) {
        return rejectWithValue({
            errorMessage: extractErrorMessage(e),
        });
    }
});
const logout = createAsyncThunk('user/logout', (_, { rejectWithValue, dispatch }) => {
    try {
        removeToken();
        dispatch(clearWishlist());
        deleteCartSessionId();
        deleteCartGtmData();
        return null;
    }
    catch (e) {
        return rejectWithValue({ errorMessage: 'Error logout' });
    }
});
const register = createAsyncThunk('user/register', async (payload, { extra, rejectWithValue, dispatch }) => {
    try {
        const { apolloConfig } = extra;
        // We can't get wishlist data within this response due to the Magento error
        // "The current user cannot perform operations on wishlist"
        const user = await publicMutate(apolloConfig(), {
            mutation: CreateCustomer,
            variables: payload,
        }).then(res => res.data.createCustomer.customer);
        const token = await publicMutate(apolloConfig(), {
            mutation: GenerateCustomerToken,
            variables: { email: payload.email, password: payload.password },
        }).then(res => res.data.generateCustomerToken.token);
        setToken(token);
        const userInfo = await privateQuery(apolloConfig(), {
            query: GetCustomerInfo,
        }, 'GetCustomerInfo').then(res => res.data.customer);
        const { wishlists } = userInfo;
        dispatch(createWishlist(wishlists));
        // Add product to the wishlist after register
        await addProductToWishlistAfterAuth(dispatch, wishlists);
        await assignCartFromGuestToLogged(apolloConfig);
        dataLayerRegister();
        // Track KWK lead confirmation
        const { siteConfig } = extra;
        if ((siteConfig === null || siteConfig === void 0 ? void 0 : siteConfig.accorAffiliateRetargetingEnabled) &&
            (siteConfig === null || siteConfig === void 0 ? void 0 : siteConfig.parentHotelCompany) === 'Accor') {
            try {
                // Use a timestamp-based identifier for GDPR compliance (not personally identifiable)
                const registrationId = `reg_${Date.now()}_${Math.random().toString(36).substring(2, 8)}`;
                await trackLeadConfirmation({ registrationId });
            }
            catch (err) {
                logger(`[KWK] Failed to track lead confirmation: ${err}`, {
                    category: 'analytics',
                    type: 'error',
                });
                // Don't throw the error, just log it
            }
        }
        return user;
    }
    catch (e) {
        logger(`[Registration] Error occurred: ${JSON.stringify(e)}`, {
            category: 'api',
            type: 'error',
        });
        return rejectWithValue({
            errorMessage: extractErrorMessage(e),
        });
    }
});

export { login, logout, register };
//# sourceMappingURL=thunks.js.map
